import { Box, Typography } from "@material-ui/core";
import { HTMLAttributes, PropsWithChildren } from "react";

export const TabPanel = (
  props: PropsWithChildren<{ index: number; value: number } & HTMLAttributes<HTMLDivElement>>,
) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

export function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
